import { render, staticRenderFns } from "./HinderDetails.vue?vue&type=template&id=519bca8b"
import script from "./HinderDetails.vue?vue&type=script&lang=js"
export * from "./HinderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports